module.exports = __webpack_public_path__ + "img/gluten.2a539e30.jpg";